import {
    GET_FEE_CATEGORIES,
    CREATE_FEE_CATEGORIES,
    GET_THIRD_PARTY_BENEFICIARIES,
    CREATE_FEE_CATEGORIES_ERROR
} from "../types/feeCategoryType";

const initialState = {
    feeCategories: [],
    thirdPartyBeneficiaries: []
    // createFeeCategoryError: {},
    // createFeeCategory: {}
};

const feeCategoryReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_FEE_CATEGORIES:
            return {
                ...state,
                feeCategories: payload
            };
        case CREATE_FEE_CATEGORIES:
            return {
                ...state,
                createFeeCategory: payload
            };
        case CREATE_FEE_CATEGORIES_ERROR:
            return {
                ...state,
                createFeeCategoryError: payload.data
            };
        case GET_THIRD_PARTY_BENEFICIARIES:
            let arrayOfBeneficiary = [];
            for (var i = 0; i < payload.length; ++i) {
                var obj = {};
                obj["id"] = payload[i].id;
                obj["name"] = payload[i].name;
                obj["status"] = payload[i].status;
                arrayOfBeneficiary.push(obj);
            }
            //  arrayOfBeneficiary;
            return {
                ...state,
                thirdPartyBeneficiaries: arrayOfBeneficiary
            };
        default:
            return state;
    }
};

export default feeCategoryReducer;
